"use client";

import { c as _c } from "react/compiler-runtime";
import { getMediaTypeInfo, type MediaCategory } from "@/helpers/file.helpers";
import { useControlledTooltip } from "@/hooks/useControlledTooltip";
import { Tooltip } from "react-tooltip";
const FORMAT_ICONS: Record<MediaCategory, {
  viewBox: string;
  path: string;
}> = {
  image: {
    viewBox: "0 0 512 512",
    path: "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
  },
  video: {
    viewBox: "0 0 576 512",
    path: "M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 336l0-48 0-64 0-48 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z"
  },
  interactive: {
    viewBox: "45 15 170 230",
    path: "M195.4,107.9c-2.6,0-5,0.4-7.4,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c-4.4-7.1-12-11.4-20.4-11.4c-2.9,0-5.7,0.5-8.4,1.4c-4.4-7.4-12.1-11.9-20.8-11.9c-1.6,0-3.1,0.1-4.6,0.4V73.9c0-14-10.7-24.9-24.4-24.9c-13.8,0-25,11.2-25,24.9v65.8l-3.9-3.9c-4.5-4.4-10.7-6.9-17.5-6.9c-6.9,0-13.6,2.6-17.9,6.9c-9.4,9.4-12.5,25.7-1.5,36.7l56.2,55.9c1.3,1.3,2.8,2.4,4.4,3.4c10.5,8.6,23.1,14.2,49.7,14.2c61.8,0,66.9-36.2,66.9-73.3v-40C220.1,118.8,209.4,107.9,195.4,107.9L195.4,107.9z M210.3,172.8c0,36-4.2,63.5-57.1,63.5c-24,0-34.5-4.7-43.7-12.2l-0.6-0.4c-1.1-0.7-2-1.4-2.9-2.2l-56.2-55.8c-7.3-7.3-3.5-17.8,1.5-22.8c2.5-2.5,6.7-4,10.9-4c4.2,0,8,1.4,10.6,4l20.6,20.5V73.8c0-8.3,6.8-15.1,15.2-15.1c8.2,0,14.6,6.6,14.6,15.1v28.5l0.1-0.1v29.3c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9V97.4c1.4-0.4,2.9-0.7,4.5-0.7c6.3,0,11.6,3.9,13.8,10.2l0.6,1.8v32.1c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9V108c1.6-0.5,3.3-0.9,4.9-0.9c6.3,0,11.6,3.9,13.8,10.2l0.3,1v32.1c0,2.7,2.2,4.9,4.9,4.9c2.7,0,4.9-2.2,4.9-4.9v-31.8c1.6-0.6,3.2-1,5.2-1c8.2,0,14.4,6.5,14.4,15.1V172.8L210.3,172.8z M68.4,120.1c0.9,0.7,1.9,1,2.9,1c1.5,0,3-0.7,4-2c1.6-2.2,1.2-5.3-1-6.9C61.1,102.4,53.5,87.4,53.5,71c0-28.3,23-51.2,51.2-51.2S156,42.8,156,71c0,3.4-0.3,6.9-1,10.2c-0.5,2.6,1.2,5.3,3.9,5.8c2.6,0.5,5.3-1.2,5.8-3.9c0.8-4,1.2-8.1,1.2-12.1c0-33.6-27.4-61-61-61S43.7,37.4,43.7,71.1C43.7,90.3,52.9,108.6,68.4,120.1L68.4,120.1z"
  }
};
interface MediaTypeBadgeProps {
  readonly mimeType: string | undefined;
  readonly dropId?: string;
  readonly size?: "sm" | "md" | "lg";
  readonly showTooltip?: boolean;
  readonly showLabel?: boolean;
  readonly tone?: "muted" | "color";
  readonly className?: string;
  readonly iconClassName?: string;
  readonly labelClassName?: string;
}
const SIZE_CLASSES = {
  sm: "tw-size-6",
  md: "tw-size-8",
  lg: "tw-size-10"
};
const ICON_SIZE_CLASSES = {
  sm: "tw-size-3",
  md: "tw-size-4",
  lg: "tw-size-5"
};
export default function MediaTypeBadge(t0) {
  const $ = _c(44);
  const {
    mimeType,
    dropId,
    size: t1,
    showTooltip: t2,
    showLabel: t3,
    tone: t4,
    className: t5,
    iconClassName: t6,
    labelClassName: t7
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  const showTooltip = t2 === undefined ? true : t2;
  const showLabel = t3 === undefined ? false : t3;
  const tone = t4 === undefined ? "muted" : t4;
  const className = t5 === undefined ? "" : t5;
  const iconClassName = t6 === undefined ? "" : t6;
  const labelClassName = t7 === undefined ? "" : t7;
  let t8;
  if ($[0] !== mimeType) {
    t8 = getMediaTypeInfo(mimeType);
    $[0] = mimeType;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const mediaInfo = t8;
  const tooltipId = dropId ? `format-badge-${dropId}` : undefined;
  const shouldRenderTooltip = showTooltip && Boolean(tooltipId);
  const {
    isOpen,
    setIsOpen,
    triggerProps
  } = useControlledTooltip();
  const t9 = SIZE_CLASSES[size];
  let iconClasses;
  if ($[2] !== shouldRenderTooltip || $[3] !== t9 || $[4] !== tone) {
    iconClasses = ["tw-flex", "tw-items-center", "tw-justify-center", "tw-rounded", "tw-border", "tw-border-solid", "tw-transition-all", "tw-duration-300", t9];
    if (shouldRenderTooltip) {
      iconClasses.push("tw-cursor-pointer");
    }
    if (tone === "muted") {
      iconClasses.push("tw-grayscale", "desktop-hover:hover:tw-grayscale-0");
    }
    $[2] = shouldRenderTooltip;
    $[3] = t9;
    $[4] = tone;
    $[5] = iconClasses;
  } else {
    iconClasses = $[5];
  }
  let t10;
  if ($[6] !== mediaInfo.label || $[7] !== shouldRenderTooltip || $[8] !== tooltipId || $[9] !== triggerProps) {
    t10 = shouldRenderTooltip ? {
      "data-tooltip-id": tooltipId,
      "data-tooltip-content": mediaInfo.label,
      "aria-label": mediaInfo.label,
      ...triggerProps
    } : {
      "aria-label": mediaInfo.label
    };
    $[6] = mediaInfo.label;
    $[7] = shouldRenderTooltip;
    $[8] = tooltipId;
    $[9] = triggerProps;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = `${iconClasses.join(" ")} ${iconClassName}`;
  let t12;
  if ($[11] !== t11) {
    t12 = t11.trim();
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== mediaInfo.styles.bg || $[14] !== mediaInfo.styles.border || $[15] !== mediaInfo.styles.text) {
    t13 = {
      color: mediaInfo.styles.text,
      backgroundColor: mediaInfo.styles.bg,
      borderColor: mediaInfo.styles.border
    };
    $[13] = mediaInfo.styles.bg;
    $[14] = mediaInfo.styles.border;
    $[15] = mediaInfo.styles.text;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const t14 = ICON_SIZE_CLASSES[size];
  const t15 = FORMAT_ICONS[mediaInfo.category];
  const t16 = FORMAT_ICONS[mediaInfo.category];
  let t17;
  if ($[17] !== t16.path) {
    t17 = <path d={t16.path} />;
    $[17] = t16.path;
    $[18] = t17;
  } else {
    t17 = $[18];
  }
  let t18;
  if ($[19] !== t14 || $[20] !== t15.viewBox || $[21] !== t17) {
    t18 = <svg className={t14} fill="currentColor" viewBox={t15.viewBox}>{t17}</svg>;
    $[19] = t14;
    $[20] = t15.viewBox;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t10 || $[24] !== t12 || $[25] !== t13 || $[26] !== t18) {
    t19 = <div {...t10} className={t12} style={t13}>{t18}</div>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t13;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  const icon = t19;
  const t20 = `tw-flex tw-flex-shrink-0 tw-items-center ${showLabel ? "tw-gap-2" : ""} ${className}`;
  let t21;
  if ($[28] !== t20) {
    t21 = t20.trim();
    $[28] = t20;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== labelClassName || $[31] !== mediaInfo.label || $[32] !== showLabel) {
    t22 = showLabel && <span className={labelClassName.trim()}>{mediaInfo.label}</span>;
    $[30] = labelClassName;
    $[31] = mediaInfo.label;
    $[32] = showLabel;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== isOpen || $[35] !== setIsOpen || $[36] !== shouldRenderTooltip || $[37] !== tooltipId) {
    t23 = shouldRenderTooltip && tooltipId && <Tooltip id={tooltipId} place="top" opacity={1} delayShow={300} isOpen={isOpen} setIsOpen={setIsOpen} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "12px",
      borderRadius: "6px",
      zIndex: 9999
    }} />;
    $[34] = isOpen;
    $[35] = setIsOpen;
    $[36] = shouldRenderTooltip;
    $[37] = tooltipId;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== icon || $[40] !== t21 || $[41] !== t22 || $[42] !== t23) {
    t24 = <div className={t21}>{icon}{t22}{t23}</div>;
    $[39] = icon;
    $[40] = t21;
    $[41] = t22;
    $[42] = t23;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  return t24;
}